<template>
  <v-layout text-xs-center>
    <v-flex xs12>
      <v-layout text-xs-center class="pt-3 pb-1 mb-1">
        <v-flex xs2 class="mt-1 mr-3 ml-2">
          <v-avatar :size="40">
            <v-img :src="jobIcon" alt="avatar"></v-img>
          </v-avatar>
          <div class="caption text-truncate name-width">
            {{character.name}}
          </div>
        </v-flex>

        <v-flex xs2 class="mt-2">
          <v-text-field height="25"
                        readonly
                        label="自動戦闘"
                        color="secondary"
                        :value="`${character.fight} m`"></v-text-field>
        </v-flex>

        <v-flex xs5 class="ml-3 mr-2">
          <v-slider
            v-model="character.fight"
            step="10"
            color="secondary"
            :min="0"
            :max="360"></v-slider>
        </v-flex>

        <v-flex xs2 class="mt-2">
          <v-btn icon flat color="secondary" @click="addFight()">
            <v-icon>add_alarm</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs2>
          <v-checkbox v-model="character.check.fight" color="success"></v-checkbox>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    props: ['character', 'index'],
    data: () => ({
      jobIcon: require('../assets/job/no.png'),
    }),
    mounted: function () {
      this.jobIcon = require(`../assets/job/${this.character.job.value}.png`);
    },
    watch: {
      'character': {
        handler: function (val) {
          const local = JSON.parse(localStorage.getItem('characters'));
          local[this.index] = JSON.parse(JSON.stringify(this.character));
          localStorage.setItem('characters', JSON.stringify(local));
        },
        deep: true
      }
    },
    methods: {
      addFight: function () {
        this.character.fight += 120;
        this.character.check.fight = true;
      },
    }
  }
</script>

<style>
.name-width {
  width: 55px;
}
</style>
